import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const TableTentCardPrinting = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for table tents?", 
            answer: "Printingy offers extensive customisation options for table tent printing, including sizes, shapes, and finishes. Our table tent card designing and printing services allow you to incorporate logos, colours, and tailored layouts that align with your branding. Options like waterproof and durable materials ensure your table tents suit various environments."
        },
        { 
            question: "Does Printingy handle bulk table tent card printing orders?", 
            answer: "Yes, Printingy specialises in bulk custom table tent card printing, making it ideal for businesses with large-scale needs. Bulk printing ensures consistent quality across all pieces while offering cost-effective solutions. Our efficient production processes and advanced technology guarantee reliable and timely delivery for all bulk projects."
        },
        { 
            question: "What industries benefit from table tent printing services?", 
            answer: "Table tent printing services are widely used in hospitality, events, retail, and corporate environments. Restaurants rely on table tents printing for menu displays, while event organisers use them for announcements or sponsorship details. Printingy tailors its solutions to meet the unique needs of each industry, ensuring professional and impactful results."
        },
        { 
            question: "What materials and finishes are available for table tents?", 
            answer: "We use high-quality materials for custom table tent card printing, including sturdy card stock and eco-friendly options. Finishes such as matte, glossy, or UV coating enhance your table tents' visual appeal and durability. These materials ensure your products maintain a professional appearance and withstand frequent handling."
        },
        { 
            question: "Does Printingy provide design assistance for table tents?", 
            answer: "Our table tent card designing and printing services include professional design assistance. Whether you have a ready concept or need creative input, our design team works with you to create visually engaging and functional layouts. From font selection to colour schemes, we ensure every detail aligns with your brand and purpose."
        },
        { 
            question: "What is the typical turnaround time for table tents printing?", 
            answer: "Turnaround times for printing table tents depend on the order's size and complexity. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for table tents printing?", 
            answer: "Printingy is committed to sustainability and offers eco-friendly options for tabletop tent card design and print services. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses aligning their marketing efforts with eco-conscious values."
        },
        { 
            question: "What factors should I consider when ordering table tents?", 
            answer: "Consider the purpose, audience, and placement when ordering custom table tent card printing. Choosing the right material, size, and design elements ensures your table tents are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your goals."
        },
        { 
            question: "How do I place an order for table tents printing?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for table tent card designing and printing. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk table tent printing cost-effective?", 
            answer: "Bulk table tent printing reduces per-unit costs, making it an economical choice for large-scale needs. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk table tents printing services ensure exceptional value while maintaining professional standards."
        }
    ];
    
    
    
    
    const [pageTitle, setPageTitle] = useState('Printing for Automotive');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Table Tent Card Printing Services"
  description="Table tents printing for businesses. Bulk custom table tent card printing and tabletop design and print solutions."
  keywords="Table tents printing,Table tent card designing and printing,Custom table tent card printing,Table top tent cards design and print
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Table Tent Card Printing</h1>
              <h2 className="text-muted">Custom tabletop tent card design and print services</h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Table tents are a versatile and impactful marketing tool, ideal for displaying promotions, menus, and announcements in high-visibility areas. Printingy offers high-quality table tent printing services, specialising in custom table tent card printing solutions that cater to diverse business needs.</p>
          <p>Our table tent card designing and printing services allow you to create visually striking and functional table tents that align with your branding. Whether for restaurants, events, or corporate environments, we ensure your table tents stand out with vibrant colours and durable materials.</p>
          <p>With options for bulk orders, custom sizes, and eco-friendly materials, Printingy provides reliable and efficient solutions. Let us help you elevate your marketing efforts with professional tabletop tent card design and print services.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Table Tent Card Printing Solutions</h2>
                <h3 className="large-hed">High-quality, customisable, and affordable table tents printing services</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert table tent card designing and printing for unique branding
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-quality custom table tent card printing with premium finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk printing options for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials for sustainable printing practices.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable finishes, including matte, glossy, and UV coating.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by restaurants, event organisers, and corporate clients.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Competitive pricing for large-scale orders without compromising quality.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/tentcards.jpg" // Path relative to the public folder
                  alt="Tabletop tent card design and print solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
        title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Table Tents Delivered On Time</h2>
            <h3 className="small-hed">Focus on your promotions while we handle your table tent printing needs </h3>
            <p>At Printingy, we combine advanced printing technology and design expertise to deliver exceptional table tents printing services. Whether you need custom table tent card printing for a promotional campaign or bulk orders for an event, we ensure precision and quality in every print.</p>
            <p>Our streamlined processes and commitment to efficiency guarantee timely delivery, even for large orders. Partner with Printingy for professional table tents that captivate your audience and enhance your brand visibility.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default TableTentCardPrinting;
